import { useRef, useEffect } from "react";

import Fast from '../../assets/fast.svg';
import World from '../../assets/world.svg';
import  Peace from '../../assets/peace.svg';
import Chrono from '../../assets/chrono.svg';
import right from '../../assets/arrow_right_alt-blue.svg';

import '../parts/parts.css';

const mod: (num: number, md: number)=>number= (num: number, md: number)=> {//<-Javascript's % does not work on negative numbers so I had to quickly write this one.
    return (num>=0) ? num%md : mod(md+num, md);
};

const TwoByTwoSlider= () => {
    
    const wrapper= useRef<HTMLDivElement>(null);

    const autoplayRef= useRef<NodeJS.Timer|null>(null);

    const totalSlides= 4;

    const prevSlide = () => {
        let active = wrapper.current?.querySelector('.active');
        let prev = wrapper.current?.querySelector('.prev');
        let activeIndex = parseInt(active?.getAttribute('data-index')||'0');
        let nextPrevIndex = mod((activeIndex - 1 - 1), totalSlides);

        let nextPrev = wrapper.current?.querySelector(`[data-index="${nextPrevIndex}"]`);
        prev?.classList.remove('prev');
        active?.classList.remove('active');
        prev?.classList.add('active');
        nextPrev?.classList.add('prev');
        startInterval();
    };
    const nextSlide = () => {
        let active = wrapper.current?.querySelector('.active');
        let prev = wrapper.current?.querySelector('.prev');
        let activeIndex = parseInt(active?.getAttribute('data-index')||'0');
        let nextActiveIndex = (activeIndex + 1) % totalSlides;
        let nextNextIndex = mod(nextActiveIndex + 1, totalSlides);

        let nextActive = wrapper.current?.querySelector(`[data-index="${nextActiveIndex}"]`);
        active?.classList.remove('active');
        active?.classList.add('prev');
        nextActive?.classList.add('active');
        prev?.classList.remove('prev');
        startInterval();
    };

    const startInterval= () => {
        if(autoplayRef.current){
            clearInterval(autoplayRef.current);
        }
        autoplayRef.current= setInterval(nextSlide, 8000);
    };

    useEffect(()=>{
        startInterval()
        return ()=>{
            if(autoplayRef.current){
                clearInterval(autoplayRef.current);
            }
        };
    }, []);
    return<>
        <div className="max-w-[1110px] w-[77%] mx-auto relative flex flex-col">
            <div className="wos-wrapper-of-wrapper relative">
                <div className="wos-wrapper" ref={wrapper}>
                    <div
                        className="flex lg:flex-row flex-col lg:gap-[30px] lg:items-start items-center gap-[20px] no-wrap opacity-0"
                        aria-hidden="true"
                    >
                        <CarSection title="Simplicité et rapidité extrême" paragraph="Inscrivez-vous, trouvez le freelance idéal, et lancez votre projet en quelques minutes, sans aucune complexité." icon={{image: Fast, alt: "Fast Icon"}} />
                        <CarSection title="Accès aux meilleurs talents, où que vous soyez" paragraph="Collaborez avec des freelances qualifiés du monde entier, et trouvez rapidement le profil parfait qui répond à vos besoins." icon={{image: World, alt: "World Icon"}} />
                    </div>{/*This element is there to give the proper height to the parent element since everything inside is positionned absolutely.*/}

                    <div
                        className="wos-slide active flex lg:flex-row flex-col lg:gap-[30px] lg:items-start items-center gap-[20px] no-wrap"
                        data-index="0"
                    >
                        <CarSection title="Excellence garantie à chaque collaboration" paragraph="Travaillez avec des freelances évalués en continu pour s’assurer d’un niveau d’expertise et d’efficacité optimal." icon={{image: Chrono, alt: "Top Chrono Icon"}} />
                        <CarSection title="Talents de haute qualité, tarifs inégalés" paragraph="Profitez des meilleurs freelances, rigoureusement sélectionnés et testés, à des prix défiant toute concurrence." icon={{image: Peace, alt: "Peace Icon"}} />
                    </div>
                    <div
                        className="wos-slide flex lg:flex-row flex-col lg:gap-[30px] lg:items-start items-center gap-[20px] no-wrap"
                        data-index="1"
                    >
                        <CarSection title="Simplicité et rapidité extrême" paragraph="Inscrivez-vous, trouvez le freelance idéal, et lancez votre projet en quelques minutes, sans aucune complexité." icon={{image: Fast, alt: "Fast Icon"}} />
                        <CarSection title="Accès aux meilleurs talents, où que vous soyez" paragraph="Collaborez avec des freelances qualifiés du monde entier, et trouvez rapidement le profil parfait qui répond à vos besoins." icon={{image: World, alt: "World Icon"}} />
                    </div>
                    <div
                        className="wos-slide flex lg:flex-row flex-col lg:gap-[30px] lg:items-start items-center gap-[20px] no-wrap"
                        data-index="2"
                    >
                        <CarSection title="Excellence garantie à chaque collaboration" paragraph="Travaillez avec des freelances évalués en continu pour s’assurer d’un niveau d’expertise et d’efficacité optimal." icon={{image: Chrono, alt: "Top Chrono Icon"}} />
                        <CarSection title="Talents de haute qualité, tarifs inégalés" paragraph="Profitez des meilleurs freelances, rigoureusement sélectionnés et testés, à des prix défiant toute concurrence." icon={{image: Peace, alt: "Peace Icon"}} />
                    </div>
                    <div
                        className="wos-slide prev flex lg:flex-row flex-col lg:gap-[30px] lg:items-start items-center gap-[20px] no-wrap"
                        data-index="3"
                    >
                        <CarSection title="Simplicité et rapidité extrême" paragraph="Inscrivez-vous, trouvez le freelance idéal, et lancez votre projet en quelques minutes, sans aucune complexité." icon={{image: Fast, alt: "Fast Icon"}} />
                        <CarSection title="Accès aux meilleurs talents, où que vous soyez" paragraph="Collaborez avec des freelances qualifiés du monde entier, et trouvez rapidement le profil parfait qui répond à vos besoins." icon={{image: World, alt: "World Icon"}} />
                    </div>
                </div>
                <button onClick={prevSlide} className="w-[48px] h-[48px] lg:flex items-center justify-center border-[1px] border-primary-blue rounded-[50%] absolute top-[50%] lg:left-[-40px] left-[0] transform translate-x-[-100%] translate-y-[-50%] hidden"><img src={right} alt="arrow-right" style={{transform: "rotate(180deg)"}} /></button>
                <button onClick={nextSlide} className="w-[48px] h-[48px] lg:flex items-center justify-center border-[1px] border-primary-blue rounded-[50%] absolute top-[50%] lg:right-[-40px] right-[0] transform translate-x-[100%] translate-y-[-50%] hidden"><img src={right} alt="arrow-left" /></button>

                <div className="w-full lg:hidden block flex justify-center gap-[30px] mt-[50px]">
                    <button onClick={prevSlide} className="w-[48px] h-[48px] flex items-center justify-center border-[1px] border-primary-blue rounded-[50%]"><img src={right} alt="arrow-right" style={{transform: "rotate(180deg)"}} /></button>
                    <button onClick={nextSlide} className="w-[48px] h-[48px] flex items-center justify-center border-[1px] border-primary-blue rounded-[50%]"><img src={right} alt="arrow-left" /></button>
                </div>
            </div>
        </div>
    </>;
};


const CarSection= ({title, paragraph, icon}: {title: string, paragraph: string, icon: {image: any, alt: string}}) => {//<- One Section of the carousel
    return<>
        <div className="rounded-[20px] bg-white flex flex-col gap-[10px] max-w-[540px] min-h-[200px] px-[40px] py-[30px]">
            <div className="flex lg:flex-row flex-col-reverse w-full lg:items-center items-start lg:gap-0 gap-[20px] justify-between">
                <div className="font-semibold lg:text-[25px] lg:leading-[30px] text-[20px] leading-[24px] text-primary-blue lg:max-w-[340px]">{title}</div>
                <img src={icon.image} alt={icon.alt} />
            </div>
            <p className="text-[#6f6f6f] lg:text-[18px] lg:leading-[23.44px] text-[16px] leading-[20.83px] font-normal font-dm-sans">{paragraph}</p>
        </div>
    </>;
};
export default TwoByTwoSlider;